// utils/status_helpers.js
// ✅ Purpose: Show a status notification with auto-clear + scroll-to-top

const statusTimers = new WeakMap();

export const showStatus = (setStatusFn, payload, duration = 20000) => {
  if (typeof setStatusFn !== "function") return;

  const existingTimer = statusTimers.get(setStatusFn);
  if (existingTimer) {
    clearTimeout(existingTimer);
    statusTimers.delete(setStatusFn);
  }

  setStatusFn(payload); // { type: "success", message: "✅ Done" }
  window.scrollTo({ top: 0, behavior: "smooth" });

  if (Number.isFinite(duration) && duration > 0) {
    const timer = setTimeout(() => {
      statusTimers.delete(setStatusFn);
      setStatusFn(null);
    }, duration);
    statusTimers.set(setStatusFn, timer);
  }
};
